export default {
    title: 'Objective periods',
    description: 'Define the time windows in which your teams set and track their objectives.',
    addPeriod: 'Add a period',
    editPeriod: 'Edit period',
    modalSubtitle: 'Define a time window for your organization objectives',
    noPeriods: 'No objective period defined yet.',
    nameLabel: 'Period name',
    namePlaceholder: 'e.g. Year 2026, First half of 2026',
    startDateLabel: 'Start date',
    endDateLabel: 'End date',
    dateRange: 'From {{start}} to {{end}}',
    detailsTab: 'Details',
    translationsTab: 'Translations',
    edit: 'Edit',
    activate: 'Activate',
    deactivate: 'Deactivate',
    complete: 'Complete',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save',
    add: 'Add',
    moreOptions: 'More options',
    saveSuccess: 'Period saved.',
    deleteSuccess: 'Period deleted.',
    statusChangeSuccess: '{{name}} has been {{action}}.',
    activated: 'activated',
    deactivated: 'deactivated',
    completed: 'completed',
    statusLabel: 'Status',
    status: {
        draft: 'Draft',
        active: 'Active',
        deactivated: 'Deactivated',
        completed: 'Completed',
    },
    deactivateTitle: 'Deactivate period',
    deactivateMessage:
        'Are you sure you want to deactivate "{{name}}"? The objectives attached to it keep it, but it will no longer be offered for a new objective.',
    completeTitle: 'Complete period',
    completeMessage:
        'Are you sure you want to complete "{{name}}"? A completed period can no longer be edited or reactivated.',
    deleteTitle: 'Delete objective period',
    deleteMessage: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
    // The base key exists for the strict `TranslationKey` type; i18next resolves the `_one` /
    // `_other` form whenever `count` is supplied, which the impact message always does.
    impactCount: '{{count}} objectives will lose their period and keep their dates.',
    impactCount_one: '{{count}} objective will lose its period and keep its dates.',
    impactCount_other: '{{count}} objectives will lose their period and keep their dates.',
    impactNone: 'No objective is attached to this period.',
    // The base key exists for the strict `TranslationKey` type; i18next resolves the `_one` /
    // `_other` form, and `count` is always supplied.
    overlapWarning: 'These dates overlap {{periods}}.',
    overlapWarning_one:
        'These dates overlap {{periods}}. That is allowed: an objective running across both periods shows under each.',
    overlapWarning_other:
        'These dates overlap {{periods}}. That is allowed: an objective running across several periods shows under each.',
    nameRequired: 'The period name is required.',
    nameMaxLength: 'The period name must not exceed {{max}} characters.',
    nameDuplicateError: 'A period with this name already exists.',
    startDateRequired: 'A start date is required.',
    endDateRequired: 'An end date is required.',
    endDateBeforeStartDate: 'The end date must be on or after the start date.',
    errorLoadingPeriods: 'Error loading objective periods',
};
